import { render, staticRenderFns } from "./FieldPurchaser.vue?vue&type=template&id=01e67550&"
import script from "./FieldPurchaser.vue?vue&type=script&lang=js&"
export * from "./FieldPurchaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports